import { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { api, errText } from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle2, XCircle, Loader2, PawPrint } from "lucide-react";

export default function Renew() {
  const { listingId } = useParams();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("loading"); // loading | ok | error
  const [info, setInfo] = useState({ title: "", expires_at: "", error: "" });

  useEffect(() => {
    if (!token) { setState("error"); setInfo((i) => ({ ...i, error: "This renewal link is missing its token." })); return; }
    api.post(`/listings/${listingId}/renew-token`, { token })
      .then((r) => { setState("ok"); setInfo({ title: r.data.title, expires_at: r.data.expires_at, error: "" }); })
      .catch((e) => { setState("error"); setInfo((i) => ({ ...i, error: errText(e) })); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16" data-testid="renew-page">
      <div className="max-w-md w-full bg-white rounded-2xl border border-slate-200/80 p-8 text-center shadow-sm">
        {state === "loading" && (
          <div data-testid="renew-loading">
            <Loader2 size={40} className="mx-auto text-[#F5551E] animate-spin" />
            <p className="text-slate-500 mt-4">Renewing your listing…</p>
          </div>
        )}
        {state === "ok" && (
          <div data-testid="renew-success">
            <span className="h-14 w-14 rounded-2xl bg-emerald-50 flex items-center justify-center mx-auto">
              <CheckCircle2 size={32} className="text-emerald-600" />
            </span>
            <h1 className="font-display text-2xl font-extrabold text-[#12234A] mt-4">Listing renewed! 🎉</h1>
            <p className="text-slate-500 mt-2">
              {info.title ? <><strong className="text-[#12234A]">{info.title}</strong> is live again</> : "Your listing is live again"}
              {info.expires_at ? <> until <strong>{info.expires_at.slice(0, 10)}</strong>.</> : " and set to stay active."}
            </p>
            <div className="flex gap-2 justify-center mt-6">
              <Link to={`/listing/${listingId}`}><Button data-testid="renew-view-btn" className="rounded-xl bg-[#F5551E] hover:bg-[#E04812] text-white">View listing</Button></Link>
              <Link to="/dashboard"><Button variant="outline" data-testid="renew-dashboard-btn" className="rounded-xl">My dashboard</Button></Link>
            </div>
          </div>
        )}
        {state === "error" && (
          <div data-testid="renew-error">
            <span className="h-14 w-14 rounded-2xl bg-red-50 flex items-center justify-center mx-auto">
              <XCircle size={32} className="text-red-500" />
            </span>
            <h1 className="font-display text-2xl font-extrabold text-[#12234A] mt-4">Couldn't renew</h1>
            <p className="text-slate-500 mt-2">{info.error || "Something went wrong."}</p>
            <div className="flex gap-2 justify-center mt-6">
              <Link to="/dashboard"><Button data-testid="renew-go-dashboard" className="rounded-xl bg-[#F5551E] hover:bg-[#E04812] text-white gap-1"><PawPrint size={15} /> Go to dashboard</Button></Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
